export const getFileUrl = function(url){
    return (
        process.env.VUE_APP_FILE_DOMAIN +
        (url.charAt(0) == "/" ? "" : "/") +
        url
      );
}